<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar class="formCard" style=" border-radius: 5px !important;padding-left:0px;height:auto !important;"
          toggleable="lg" type="dark" variant="primary">
          <b-navbar-brand center>Purchase Order Details</b-navbar-brand>

          <b-navbar-nav class="ml-auto" center>
            <b-nav-form>
              <b-button size="sm" variant="warning" @click="goToMain">New Purchase Order</b-button>
            </b-nav-form>
          </b-navbar-nav>
        </b-navbar>
        <b-card class="formCard">
          <b-card-text>
            <b-container fluid>
              <b-row class="gutr">
                <b-col md="12" class="my-1">
                  <b-form-group>
                    <b-input-group>
                      <b-form-input :formatter="capitalizeAll" v-model="filter" placeholder="Type to Search" />
                      <b-input-group-append>
                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
              <!-- Main table element -->
              <div class="table-responsive tableMain">
                <b-table show-empty stacked="md" :items="stockList" :fields="fields" :current-page="currentPage"
                  :per-page="perPage" :filter="filter" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
                  :sort-direction="sortDirection" @filtered="onFiltered">
                  <template slot="poOrderId" slot-scope="row0">
                    <span>{{row0.index + 1 + (currentPage - 1) * perPage }}</span>
                  </template>
                  <template slot="poOrderSeries" slot-scope="row1">
                    <span @click="viewPoPage(row1.item.poOrderId)"
                      class="showMoreData">{{row1.item.poOrderSeries}}</span>
                  </template>

                  <template slot="poDate" slot-scope="row12">
                    <span>{{row12.item.poDate | moment}}</span>
                  </template>
                  <template slot="loginTime" slot-scope="row116">
                    <span>{{row116.item.loginTime | moment}}</span>
                  </template>
                  <template slot="poOrder_pdf" slot-scope="row14">
                    <b-button v-if="row14.item.poOrder_pdf != null" @click="PrintNote(row14.item.poOrder_pdf)" size="sm"
                      variant="outline-success">PDF</b-button>
                    <span v-else>N/A</span>
                  </template>
                </b-table>
              </div>
              <b-row>
                <b-col md="12" class="my-1">
                  <b-pagination limit="5" :total-rows="totalRows" :per-page="perPage" v-model="currentPage"
                    class="my-0 pull-right" />
                </b-col>
              </b-row>
            </b-container>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
  </div>
</template>




<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../../helper/filters";
import { globalPermissionStatus } from "../../../helper/collection";

export default {
  beforeMount() {
    if (globalPermissionStatus("Maintanence")) {
      this.$store.dispatch("setCurrentRoute", "/poOrder/viewPoOrder");
      this.viewStockDetail();
    } else {
      this.$router.push({
        path: "/dashboard"
      });
    }
  },

  data() {
    return {
      fields: [
        {
          key: "poOrderId",
          label: "Sr No.",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "poOrderSeries",
          label: "Purchase Order No.",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "poDate",
          label: "Purchase Order Date",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "maintenanceType",
          label: "Maintenance Type",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "itemName",
          label: "Item Details",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "loginTime",
          label: "Creation Date",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "poOrder_pdf",
          label: "PDF",
          sortable: true,
          sortDirection: "desc"
        },        
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: "",
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: "desc",
      filter: null,
      modalInfo: { title: "", content: "" },
      isLoading: false,
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok"
      },
      clientId: "",
      stockList: [],
      docURL: URL_BASE_DOC,
    };
  },

  mounted() {},
  filters: {
    moment(date) {
      return DateFormat(date)
    }
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    // Loading
    CustomLoader,
  },

  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    }
  },
  methods: {
    PrintNote(poOrder_pdf) {
      let key = "ASSIGNMENT_UPLOADS/PoOrder/" + poOrder_pdf;
      this.openSignedDocument(key);
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    goToMain() {
      this.$sessionsStorage.set("editPOId", "");
      this.$router.push({
        path: "/poOrder/poOrder"
      });
    },
    doLoading() {
      this.isLoading = true;
    },
    doLoadingClose() {
      this.isLoading = true;

      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    JqueryFun() {
      return $(function() {
        return $("#po").DataTable();
      });
    },

    viewPoPage(poID) {
      this.$sessionsStorage.set("editPOId", poID);
      this.$router.push({
        path: "/poOrder/poOrder"
      });
    },

    viewStockDetail() {
      this.doLoading();
      let payload = {
        view: "view",
        poOrderId: ""
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Maintenance/viewPoOrder.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };
      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if (
            data.clientId != "" &&
            
            status == 200 &&
            data
          ) {
            if (data.itemArray.length > 0) {
              this.stockList = data.itemArray;
              this.totalRows = data.itemArray.length;
            }
            this.doLoadingClose();
            this.JqueryFun();
          }
        })
        .catch(error => {});
    }
  }
};
</script> 
<style>

</style>




// WEBPACK FOOTER //
// viewPoOrder.vue?c831ca74